import { render, staticRenderFns } from "./PhysicalMonitoring.vue?vue&type=template&id=44532aec&scoped=true"
import script from "./PhysicalMonitoring.vue?vue&type=script&lang=js"
export * from "./PhysicalMonitoring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44532aec",
  null
  
)

export default component.exports